import type { FC, SVGProps } from 'react';

/**
 * Workfront ("Core") product icon — verbatim from the legacy
 * `wf-audit/src/slices/common/components/icons/CoreIcon.tsx`.
 */
const WorkfrontIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_core)">
      <path
        d="M36.5954 31.5166C36.5954 30.9534 36.9474 30.4734 37.4434 30.2846C37.3154 29.7438 37.101 29.2286 36.8098 28.755C36.6402 28.8286 36.4578 28.8702 36.2722 28.8702C35.933 28.8702 35.597 28.7422 35.3378 28.483C34.941 28.0862 34.8482 27.4974 35.0658 27.011C34.5922 26.7198 34.077 26.5054 33.5362 26.3774C33.3474 26.8734 32.8642 27.2254 32.3042 27.2254C31.7442 27.2254 31.261 26.8734 31.0722 26.3774C30.5314 26.5054 30.0162 26.7198 29.5426 27.011C29.757 27.4974 29.6674 28.0862 29.2706 28.483C29.0114 28.7422 28.6754 28.8702 28.3362 28.8702C28.1506 28.8702 27.9682 28.8318 27.7986 28.755C27.5074 29.2286 27.293 29.7438 27.165 30.2846C27.661 30.4766 28.013 30.9566 28.013 31.5166C28.013 32.0766 27.661 32.5598 27.165 32.7486C27.293 33.2894 27.5074 33.8046 27.7986 34.2782C27.9682 34.2046 28.1506 34.1662 28.3362 34.1662C28.6754 34.1662 29.0114 34.2942 29.2706 34.5534C29.6674 34.9502 29.7602 35.539 29.5426 36.0222C30.0162 36.3134 30.5314 36.5278 31.0722 36.6558C31.2642 36.1598 31.7442 35.811 32.3042 35.811C32.8642 35.811 33.3474 36.163 33.5362 36.6558C34.077 36.5278 34.5922 36.3134 35.0658 36.0222C34.8514 35.539 34.941 34.9502 35.3378 34.5534C35.597 34.2942 35.933 34.1662 36.2722 34.1662C36.4546 34.1662 36.637 34.2046 36.8098 34.2782C37.101 33.8046 37.3154 33.2894 37.4434 32.7486C36.9474 32.5566 36.5954 32.0766 36.5954 31.5166ZM32.3266 33.6542C31.1394 33.6542 30.1858 32.6942 30.1858 31.5134C30.1858 30.3326 31.1426 29.3726 32.3266 29.3726C33.5106 29.3726 34.4674 30.3326 34.4674 31.5134C34.4674 32.6942 33.5106 33.6542 32.3266 33.6542Z"
        fill="var(--brand-yellow)"
      />
      <path
        d="M25.648 57.1683C11.8688 57.1683 0.65918 45.9587 0.65918 32.1794C0.65918 18.4002 11.8688 7.19385 25.648 7.19385C39.4272 7.19385 50.6368 18.4034 50.6368 32.1826C50.6368 45.9618 39.4272 57.1715 25.648 57.1715V57.1683ZM25.648 8.62105C12.656 8.62105 2.08958 19.1906 2.08958 32.1794C2.08958 45.1683 12.6592 55.7379 25.648 55.7379C38.6368 55.7379 49.2064 45.1683 49.2064 32.1794C49.2064 19.1906 38.6368 8.62105 25.648 8.62105Z"
        fill="var(--brand-blue)"
      />
      <path
        d="M38.3521 57.1683C24.5729 57.1683 13.3633 45.9587 13.3633 32.1794C13.3633 18.4002 24.5729 7.19385 38.3521 7.19385C52.1313 7.19385 63.3409 18.4034 63.3409 32.1826C63.3409 45.9618 52.1313 57.1715 38.3521 57.1715V57.1683ZM38.3521 8.62105C25.3633 8.62105 14.7937 19.1906 14.7937 32.1794C14.7937 45.1683 25.3633 55.7379 38.3521 55.7379C51.3409 55.7379 61.9105 45.1683 61.9105 32.1794C61.9105 19.1906 51.3441 8.62105 38.3521 8.62105Z"
        fill="var(--brand-blue)"
      />
      <path
        d="M27.2068 38.7523L29.1236 38.4227C29.5268 38.3683 29.8084 37.9971 29.7508 37.5971C29.6964 37.1939 29.3252 36.9123 28.9252 36.9699C28.9092 36.9699 28.89 36.9763 28.8741 36.9795L25.386 37.5779C24.986 37.6451 24.7172 38.0259 24.7876 38.4259L25.386 41.9139C25.4692 42.3107 25.8565 42.5667 26.2565 42.4835C26.634 42.4035 26.8868 42.0483 26.8356 41.6643L26.5668 40.0963C28.266 41.2259 30.2628 41.8275 32.3012 41.8243C34.9572 41.8243 37.6132 40.8195 39.6164 38.8195C42.3428 36.0995 43.3284 32.0899 42.1732 28.4163C42.0516 28.0291 41.6388 27.8147 41.2516 27.9363C40.8645 28.0579 40.65 28.4707 40.7717 28.8579C41.7636 32.0099 40.9188 35.4531 38.5796 37.7859C35.514 40.8515 30.666 41.1811 27.21 38.7587L27.2068 38.7523ZM37.4052 24.2595L35.482 24.5891C35.0788 24.6435 34.7972 25.0147 34.8548 25.4147C34.9092 25.8179 35.2804 26.0995 35.6804 26.0419C35.6964 26.0419 35.7157 26.0355 35.7317 26.0323L39.2196 25.4339C39.6196 25.3667 39.8884 24.9859 39.818 24.5859L39.2196 21.0979C39.1524 20.6979 38.7717 20.4291 38.3717 20.4995C37.9716 20.5667 37.7028 20.9475 37.7732 21.3475L38.042 22.9091C33.9492 20.1411 28.4676 20.6819 24.9924 24.1923C22.266 26.9123 21.2804 30.9219 22.4356 34.5955C22.5572 34.9827 22.97 35.1971 23.3572 35.0755C23.7444 34.9539 23.9588 34.5411 23.8372 34.1539C22.8452 31.0019 23.69 27.5619 26.0292 25.2259C29.0692 22.1571 33.8852 21.7443 37.4052 24.2531V24.2595Z"
        fill="var(--brand-yellow)"
      />
      <path
        d="M35.1427 5.33447H29.4595C29.1113 5.33447 28.8291 5.61671 28.8291 5.96487V11.6481C28.8291 11.9962 29.1113 12.2785 29.4595 12.2785H35.1427C35.4909 12.2785 35.7731 11.9962 35.7731 11.6481V5.96487C35.7731 5.61671 35.4909 5.33447 35.1427 5.33447Z"
        fill="var(--brand-blue)"
      />
      <path
        d="M35.1681 52.0288H29.4849C29.1367 52.0288 28.8545 52.311 28.8545 52.6592V58.3424C28.8545 58.6906 29.1367 58.9728 29.4849 58.9728H35.1681C35.5163 58.9728 35.7985 58.6906 35.7985 58.3424V52.6592C35.7985 52.311 35.5163 52.0288 35.1681 52.0288Z"
        fill="var(--brand-blue)"
      />
      <path d="M33.0427 12.0835H31.6123V21.2291H33.0427V12.0835Z" fill="url(#paint0_linear_core)" />
      <path
        d="M31.7047 41.7184L31.6094 52.022L33.0397 52.0352L33.135 41.7316L31.7047 41.7184Z"
        fill="url(#paint1_linear_core)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_core"
        x1="30.0868"
        y1="20.2458"
        x2="34.6104"
        y2="13.0429"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: 'var(--brand-yellow)' }} />
        <stop offset="1" style={{ stopColor: 'var(--brand-blue)' }} />
      </linearGradient>
      <linearGradient
        id="paint1_linear_core"
        x1="32.6017"
        y1="45.1159"
        x2="27.4592"
        y2="53.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop style={{ stopColor: 'var(--brand-yellow)' }} />
        <stop offset="1" style={{ stopColor: 'var(--brand-blue)' }} />
      </linearGradient>
      <clipPath id="clip0_core">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default WorkfrontIcon;
